// extracted by mini-css-extract-plugin
export default {"box":"JuyoIKLLNmHEhc6IAhfm","moduleBox":"_Djv33cajLOY4mpFy2lT"};